import { FC } from 'react';
// components
import ServingSizeComponent from 'components/main/ServingSize/Edit';

const AddServingSize: FC = () => <ServingSizeComponent />;

export default AddServingSize;
